//  ----------      START   IMPORT  BLOCK       ----------
import { useState, useCallback } from 'react';
import RegisterService from '../Services/RegisterService';
//  ----------      END   IMPORT  BLOCK       ----------

export const useRegister = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);

  const [isCheckingUsername, setIsCheckingUsername] = useState(false);
  const [usernameStatus, setUsernameStatus] = useState(null);

  const registerService = new RegisterService();
  const register = useCallback(async (registrationData) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);

    try {
      const response = await registerService.register(registrationData);
      setIsSuccess(true);
      return response;
    } catch (err) {
      const errorMessage = err.response?.data?.detail || "Registration failed. Please try again.";
      setError(errorMessage);
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, []);

  // 🎯 New Username Availability Checker
  const checkUsername = useCallback(async (username) => {
    if (!username || username.trim().length < 3) {
      setUsernameStatus(null);
      return;
    }

    setIsCheckingUsername(true);
    try {
      // API Returns: { username: "doc", available: true }
      const response = await registerService.checkUsername(username.trim());
      
      if (response && response.available) {
        setUsernameStatus('available');
      } else {
        setUsernameStatus('taken');
      }
      return response;
    } catch (err) {
      console.error("Error checking username availability:", err);
      setUsernameStatus('error');
    } finally {
      setIsCheckingUsername(false);
    }
  }, []);

  return { 
    register, 
    isLoading, 
    error, 
    isSuccess,
    // Username Check Exports
    checkUsername,
    isCheckingUsername,
    usernameStatus,
    setUsernameStatus
  };
};